import React from 'react';

interface IProps {
  style?: any;
}

const DownloadIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={props.style}>
        <path d="M3.94555 0V7.635L1.98055 5.685L1.18555 6.48L4.50055 9.795L7.81555 6.48L7.02055 5.685L5.07055 7.635V0H3.94555Z" fill="white"/>
        <path d="M9 10.875H0V12H9V10.875Z" fill="white"/>
    </svg>
  )
}

export default DownloadIcon;